const translationModifier = str => str.replace(/Interactive/g, "Enhanced")

export default translationModifier
